<template>
  <div class="validation_request_customer_container">
    <h4>Client<slot name="title_suffix"></slot></h4>
    
    <div class="validation_request_customer_body_container" v-if="view_details || enable_details == false">
      <div class="validation_request_customer_description">
        <h5>Informations</h5>

        <p>
          <router-link :to="{ name: 'customer', params: { id: customer.id } }" 
            style="font-size: 16px; color:#fb557a;"
          >
            {{customer.decoded_civility}} {{customer.name}}
          </router-link>
        </p>

        <ul class="validation_request_customer_description_list">
          <li>Groupe : {{customer.decoded_legal_form_group}}</li>
          <li>Type : {{customer.decoded_legal_form}}</li>
          <li>Origine : {{customer.decoded_origin}}</li>
          <li>SIRET : {{customer.siret}}</li>
          <li v-if="customer.naf">NAF : {{customer.naf}}</li>
          <li v-if="customer.trade_name">Nom commercial : {{customer.trade_name}}</li>
          <li v-if="customer.initials">Initiales : {{customer.initials}}</li>
          <li>Status : {{customer.decoded_status}}</li>
          <li>Vigilance : {{customer.decoded_vigilance_status}}</li>
          <li>Type de facturation : {{customer.decoded_billing_periodicity}}
          <li v-if="customer.electronic_invoice">Facturation éléctronique</li>
          <li v-if="customer.postal_proxy">Procuration postale</li>
          <li>Activité : {{customer.activity}}</li>
          <li>Emploie des salariés : 
            <span v-if="!customer.without_employee">Oui</span>
            <span v-else>Non</span>
          </li>
          <li v-if="customer.comments">
            Commentaires :
            <p>
              {{customer.comments}}
            </p>
          </li>
        </ul>
      </div>

      <!-- <customer-address v-if="mainAddress" :validation_requestable="mainAddress"></customer-address>

      <customer-address v-if="correspondingAddress" :validation_requestable="correspondingAddress"></customer-address> -->
    </div>
  </div>
</template>

<script>
  import CustomerAddress from "components/Demands/Details/ValidationRequestable/Address"

  export default {
    name:"ValidationRequestableCustomer",

    components:{
      CustomerAddress
    },

    props:["customer","enable_details"],

    data () {
      return {
        detailed_view:false,
      }
    },

    methods : {
      toggle() {
        this.detailed_view = !this.detailed_view
      },
    },

    computed: {
      view_details () {
        return this.detailed_view
      },

      // mainAddress() {
      //   if (this.customer && this.customer.hasOwnProperty('addresses')) {
      //     return _.find(this.customer.addresses, function(address) {
      //       return 'customer' == address.type && 'main' == address.customer_usage
      //     })
      //   }

      //   return null
      // },

      // correspondingAddress() {
      //   if (this.customer && this.customer.hasOwnProperty('addresses')) {
      //     return _.find(this.customer.addresses, function(address) {
      //       return 'customer' == address.type && 'corresponding' == address.customer_usage
      //     })
      //   }

      //   return null
      // }
    }
  }
</script>

<style scoped>
.validation_request_customer_container {
  padding: 0 15px;
  width: 100%;
  background-color: white;
}

.validation_request_customer_description {
  padding: 0 15px;
  border: solid 1px lightgray;
  background-color: white;
}

.validation_request_customer_description > h5 {
  border-bottom: 1px solid lightgray;
  padding-bottom: 5px;
}

.head a {
  display: inline-block;
}

.head button {
  display: inline-block;
}

@media screen and (max-width: 800px) {
  .validation_request_customer_container {
    margin: 0;
    margin-bottom: 15px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Customer.vue